const Loading = () => {
  return (
    <>
      <div className="z-[6000] fixed inset-0 flex justify-center items-center bg-black opacity-50"/>
      <div className="z-[7000] fixed inset-0 flex justify-center items-center">
        <img className="z-10 max-h-24 max-w-24" src="/spinner.gif"
          alt="spinner"/>
      </div>
    </>
  );
};

export default Loading;
